














import { Component, Prop, Mixins } from 'vue-property-decorator';
import Emitter from '../../../common/mixins/emitter';
import { FitIcon } from '@tencent/wphk-ui';
@Component({
  components: {
    FitIcon,
  },
})
export default class FitSelectItem extends Mixins(Emitter) {
  @Prop() value;
  @Prop({ default: '' }) label;
  @Prop({ default: false }) disabled;
  @Prop({ default: false }) checked;
  select: any = {};
  get itemSelected() {
    return this.select.curValue === this.value;
  }
  onChange() {
    if (this.disabled) {
      return;
    }
    this.dispatch('FitSelect', 'handleOptionClick', this.value);
  }
  mounted() {
    this.dispatch('FitSelect', 'registerItem', (select) => {
      this.select = select;
    });
  }
}
